import React from 'react';
import {
  LeftIconContainer,
  RightIconContainer,
  StyledIconButton,
  TitleContainer,
} from './styled.iconButton';
import { IIconButton } from '../../../@types/iconButton';

export function IconButton ({
  onClick,
  disabled,
  leftIcon,
  title,
  rightIcon,
}: IIconButton) {
  return (
    <StyledIconButton onClick={onClick} disabled={disabled}>
      {leftIcon && <LeftIconContainer>{leftIcon}</LeftIconContainer>}
      <TitleContainer>{title}</TitleContainer>
      {rightIcon && <RightIconContainer>{rightIcon}</RightIconContainer>}
    </StyledIconButton>
  );
}
